import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=24bd1a1c&scoped=true"
import script from "./cases.vue?vue&type=script&lang=js"
export * from "./cases.vue?vue&type=script&lang=js"
import style0 from "./cases.vue?vue&type=style&index=0&id=24bd1a1c&prod&scoped=true&lang=css"
import style1 from "./cases.vue?vue&type=style&index=1&id=24bd1a1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bd1a1c",
  null
  
)

export default component.exports